/*
 * @Author: chen
 * @Date: 2023-02-10 16:17:49
 * @LastEditors: Do not edit
 * @LastEditTime: 2024-08-20 11:09:05
 * @Description: 
 * @FilePath: \xxsy_huiyi\src\http\api.js
 */
import http from '@/http/index.js' //axios 请求引入


const api = {

   sIndex(param){
      return http.get("/ac1/conference/mingsha",param); //专题会议首页
   },

   sConflist(param){
      return http.get("/ac1/conference/conflist",param); //专题会议目录列表
   },

   sharePageIndex(param){
      return http.post("/ac1/conference/sharePage/index",param); //分享页主页
   },

   newsDetail(param){
      return http.get("/ac1/conference/newsDetail",param); //会议资讯详情页
   },

   indexcolumn(param){
      return http.get("/ac1/conference/column/indexcolumn",param); //会议首页菜单栏
   },
   getuserhistory(param){
      return http.get("/ac1/conference/getuserhistory",param); //获取往届报名信息
   },
}

export default api
